<div class="row layout-top-spacing">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
        <div class="widget widget-five">
            <div class="widget-content">
                <div class="header">
                    <div class="cd-section" id="pricing">
                        <div class="pricing-1" id="pricing-1">
                            <!-- *ngIf="step=='first'" -->
                            <div class="container-fluid" style="display: flex;">
                                <!-- <div class="center" >
                            <i style="font-size: 48px;cursor:pointer; color: #be0000;" (click)="scrollLeft()" class="fa fa-chevron-circle-left"></i>
                        </div> -->
                                <div class="text-center sd row">
                                    <!-- <div class="text-center sd" id="myDiv"> -->
                                    <div class="col-md-3 cols" (click)="showStepSecond('all')">
                                        <div class="box-wrapper effect7 hvr-bounce-in">
                                            <img class="height190" src="assets/images/kolkata-1.jpg" alt="rhcp" />
                                            <div class="box-content">
                                                <a class="buy" href="javascript:void(0)">
                                                    <span>
                                                        <img style="border-radius: 100%;" src="assets/img/letter-k.png">
                                                    </span>
                                                </a>
                                                <div class="title mt-2">All</div>
                                                <div id="traffic-chart-legend"
                                                    class="chartjs-legend traffic-chart-legend">
                                                    <ul>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#673AB7">
                                                                </span>
                                                                <span>Total</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background:#383838">
                                                                1400</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#FFB30F">
                                                                </span>
                                                                <span>Affixed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #F44336;">
                                                                200</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#008080">
                                                                </span>
                                                                <span>Transit</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #9C27B0;">
                                                                600</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#BE0000">
                                                                </span>
                                                                <span>Completed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #0063cb;">
                                                                600</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="success"></div>
                                        </div>
                                    </div>

                                    <div class="col-md-3 cols" (click)="showStepSecond('imz')">
                                        <div class=" box-wrapper hvr-bounce-in">
                                            <img class="height190" src="assets/images/business-1845350.jpg"
                                                alt="rhcp" />
                                            <div class="box-content">
                                                <a class="buy" href="javascript:void(0)">
                                                    <span>
                                                        <img style="border-radius: 100%;" src="assets/img/letter-i.png">
                                                    </span>
                                                </a>
                                                <div class="title mt-2">IMZ</div>
                                                <div id="traffic-chart-legend"
                                                    class="chartjs-legend traffic-chart-legend">
                                                    <ul>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#673AB7">
                                                                </span>
                                                                <span>Total</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background:#383838">
                                                                10</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#FFB30F">
                                                                </span>
                                                                <span>Affixed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #F44336;">
                                                                2
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#008080">
                                                                </span>
                                                                <span>Transit</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #9C27B0;">
                                                                3
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#BE0000">
                                                                </span>
                                                                <span>Completed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #0063cb;">
                                                                5
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="success"></div>
                                        </div>
                                    </div>

                                    <div class="col-md-3 cols" (click)="showStepSecond('transecur')">
                                        <div class=" box-wrapper hvr-bounce-in">
                                            <img class="height190" src="assets/images/Dcqy22CW4AAHOed.jpg" alt="rhcp" />
                                            <div class="box-content">
                                                <a class="buy" href="javascript:void(0)">
                                                    <span>
                                                        <img style="border-radius: 100%;" src="assets/img/letter-t.png">
                                                    </span>
                                                </a>
                                                <div class="title mt-2">Transecur</div>
                                                <div id="traffic-chart-legend"
                                                    class="chartjs-legend traffic-chart-legend">
                                                    <ul>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#673AB7">
                                                                </span>
                                                                <span>Total</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background:#383838">
                                                                77</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#FFB30F">
                                                                </span>
                                                                <span>Affixed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #F44336;">
                                                                30
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#008080">
                                                                </span>
                                                                <span>Transit</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #9C27B0;">
                                                                1
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#BE0000">
                                                                </span>
                                                                <span>Completed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #0063cb;">
                                                                44
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="success"></div>
                                        </div>
                                    </div>

                                    <div class="col-md-3 cols" (click)="showStepSecond('traqpro')">
                                        <div class=" box-wrapper hvr-bounce-in">
                                            <img class="height190"
                                                src="assets/images/Nepal-Keen-on-Using-Vizag-Port-for-Cargo-Import.jpg"
                                                alt="rhcp" />
                                            <div class="box-content">
                                                <a class="buy" href="javascript:void(0)">
                                                    <span>
                                                        <img style="border-radius: 100%;" src="assets/img/letter-v.png">
                                                    </span>
                                                    
                                                </a>
                                                <div class="title mt-2">Traqpro</div>
                                                <div id="traffic-chart-legend"
                                                    class="chartjs-legend traffic-chart-legend">
                                                    <ul>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#673AB7">
                                                                </span>
                                                                <span>Total</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background:#383838">
                                                                180</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#FFB30F">
                                                                </span>
                                                                <span>Affixed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #F44336;">
                                                                30</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#008080">
                                                                </span>
                                                                <span>Transit</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #9C27B0;">
                                                                40</div>
                                                        </li>
                                                        <li>
                                                            <div class="d-flex align-items-center">
                                                                <span class="legend-dots" style="background:#BE0000">
                                                                </span>
                                                                <span>Completed</span>
                                                            </div>
                                                            <div class="mr1 badge badge-info mb-2"
                                                                style="background: #0063cb;">
                                                                60</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="success"></div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="center">
                            <i style="font-size: 48px;cursor:pointer; color: #be0000;" (click)="scrollRight()" class="fa fa-chevron-circle-right"></i>
                        </div> -->
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>